module.exports = __webpack_public_path__ + "img/erweima.bc130cfd.png";